import React, { useEffect, useState, useRef } from 'react';
import { Container, CircularProgress, Typography, Paper, Toolbar, Button, Grid, Divider } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { connect } from 'react-redux'
import { compose, bindActionCreators } from 'redux';
import EditIcon from '@material-ui/icons/Edit';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import BlockIcon from '@material-ui/icons/Block';
import { IdentityActions, AccountActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        fontSize: '18px'
    },
    infoTitle: {
        "& h3": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 0 auto'
        }
    },
    table: {
        "& td": {
            paddingRight: '10px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const accountsSelector = (state) => state.Accounts;
const IdentitySelector = (state) => state.Identity;

const AccountDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const accountActions = bindActionCreators(AccountActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(accountsSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    /**
     * 
     * 戻るボタン押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 編集ボタン押下時の処理
     * 
     */
    const onEditClick = () => {
        props.onEdit();
    }

    /**
     * 
     * 無効化ボタン押下時の処理
     * 
     */
    const onDisableClick = () => {
        accountActions.setEnable(token, editing, false)
            .then(data => {
                notificationActions.showSuccess('登録しました。');
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     * 
     * 有効化ボタン押下時の処理
     * 
     */
        const onEnableClick = () => {
            accountActions.setEnable(token, editing, true)
                .then(data => {
                    notificationActions.showSuccess('登録しました。');
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }

    var editButton = <div></div>;
    var disableButton = <div></div>; 

    if (permissions.fid5_8 != null && (permissions.fid5_8.value.value & 2) == 2) {
        editButton =
            <div>
                <Button fullWidth id="editButton" variant="contained" size="medium" color="primary"
                    endIcon={<EditIcon />}
                    onClick={onEditClick}>編集</Button>
            </div>;

        if (editing.status == 1) {
            disableButton =
                <Button fullWidth variant="contained" size="medium"
                    endIcon={<BlockIcon />}
                    onClick={onDisableClick}>「{editing.name}」を無効化</Button>;
        }
        else {
            disableButton =
                <Button fullWidth variant="contained" size="medium"
                    endIcon={<BlockIcon />}
                    onClick={onEnableClick}>「{editing.name}」を有効化</Button>;
        }
    }

    var orgNameElement;
    if (editing.role == 3 || editing.role == 4 || editing.role == 5) {
        // 加盟店、代表加盟店、店舗アカウントは所属を表示（システム管理者、沖縄ICカードアカウントは非表示）
        orgNameElement = <tr><td><FormattedMessage id={"Account.Org"} /></td><td>{editing.org_name}</td></tr>;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit">アカウント</Typography>
                    </div>
                </Toolbar>

                <form className={classes.form}>
                    <Grid container spacing={2} justify="center">
                        <Grid item xs={12}>
                            <div className={classes.infoTitle}>
                                <Typography id="infoTitle" component="h3" variant="inherit">アカウント情報</Typography>
                                {editButton}
                            </div>

                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <table className={classes.table}>
                                <tbody>
                                    <tr><td><FormattedMessage id={"Account.Username"} /></td><td>{editing.username}</td></tr>
                                    <tr><td><FormattedMessage id={"Account.Name"} /></td><td>{editing.name}</td></tr>
                                    <tr><td><FormattedMessage id={"Account.Status"} /></td><td>{editing.status == 1 ? '有効' : '無効'}</td></tr>
                                    <tr><td><FormattedMessage id={"Account.Role"} /></td><td>{editing.role_name}</td></tr>
                                    {orgNameElement}
                                    <tr>
                                        <td valign="top">権限</td>
                                        <td>
                                            <table>
                                                <tbody>
                                                {Object.keys(editing.permissions).map((fld) => {
                                                    var permission = editing.permissions[fld];
                                                    return (
                                                        <tr key={permission.type.id}>
                                                            <td>{permission.type.name}</td>
                                                            <td>{permission.value.title}</td>
                                                        </tr>
                                                    )
                                                })}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </Grid>

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={3} sm={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                            </Grid>
                            <Grid item xs={3} sm={6}>
                                {disableButton}
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )    
}

export default withStyles(style, { withTheme: true })(AccountDetail);